export const useStyles = () => ({
  container: {
    '& .MuiGrid-root': {
      justifyContent: 'center',
    },
  },
  loader: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})
